import { Box, Typography } from '@mui/material';
import WhatsAppTextFormatter from 'components/@home/@messages/ChatPanel/MessagesList/MessageGroup/WhatsAppTextFormatter';
import MessageIcon from 'components/common/MessageIcon';
import PropTypes from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';
import messageShape from 'shapes/message';
import { getMessageType, MESSAGE_TYPES } from 'utils/getMessageType';

const MEDIA_TYPES = new Set([MESSAGE_TYPES.IMAGE, MESSAGE_TYPES.VIDEO, MESSAGE_TYPES.AUDIO]);

const sameText = (a, b) =>
  typeof a === 'string' &&
  typeof b === 'string' &&
  a.trim() !== '' &&
  a.trim().toLowerCase() === b.trim().toLowerCase();

const MessagePreview = ({ message = null, showImages = true, sx = {} }) => {
  if (!message) {
    return null;
  }
  const messageText = {
    [MESSAGE_TYPES.FILE]: message.attachments?.[0]?.name,
    [MESSAGE_TYPES.AUDIO]: I18n.t('LastMessage.AttachmentBubble.Audio'),
    [MESSAGE_TYPES.IMAGE]: I18n.t('LastMessage.AttachmentBubble.Image'),
    [MESSAGE_TYPES.VIDEO]: I18n.t('LastMessage.AttachmentBubble.Video'),
  };
  const type = getMessageType(message);
  const attachmentName = message.attachments?.[0]?.name;
  const caption = message.text?.replace('attachments', '').trim() || '';
  const captionIsFilename = sameText(caption, attachmentName) || sameText(caption, message.title);
  const textPreview = message.softDeletedAt
    ? I18n.t('Message.deleted')
    : (caption && !captionIsFilename ? caption : '') ||
      messageText[type] ||
      (MEDIA_TYPES.has(type) ? '' : message.title || message.article?.title || '');

  return (
    <Box
      sx={{
        display: 'inline',
        lineHeight: '1.2em',
        '& *:first-child': {
          marginRight: '2px',
        },
        '& *:last-child': {
          marginRight: 0,
        },
        '& > * + *': {
          marginLeft: '3px',
        },
        '& .message-preview-text': {
          lineHeight: '1em',
          color: 'secondary.main',
          '& *': {
            verticalAlign: 'baseline',
          },
        },
        ...sx,
      }}
    >
      <MessageIcon message={message} showImages={showImages} />
      <Typography
        component="span"
        className="message-preview-text"
        sx={[
          {
            display: 'inline',
          },
          message.softDeletedAt ? { fontStyle: 'oblique' } : undefined,
        ]}
      >
        {/* inline: unwrap block markdown (headings, tables) for one-line previews */}
        <WhatsAppTextFormatter inline disableLinks>
          {textPreview}
        </WhatsAppTextFormatter>
      </Typography>
    </Box>
  );
};

MessagePreview.propTypes = {
  message: messageShape,
  showImages: PropTypes.bool,
  sx: PropTypes.object,
};

export default MessagePreview;
